<template>
  <div>
    <div class="relative py-16 mx-auto" style="width: 800px">
      <div class="text-2xl font-semibold text-gray-92 leading-8 pb-8">
        お知らせ
      </div>
      <div class="mb-4 bg-white rounded-lg">
        <NotificationCard
          v-for="(notification, index) in state.notifications"
          :notification="notification"
          :key="notification.id"
          :is-first-item="index === 0"
          :check-for-get-api="
            !state.isLastPage && index === state.notifications.length - 5
          "
          @getApi="getNotificationData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, inject, onMounted } from 'vue';
import axios from '@/utils/axiosAuth.js';
import NotificationCard from '@/views/notification/vue/NotificationCard.vue';

export default {
  components: {
    NotificationCard,
  },
  setup() {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      currentPage: 0,
      notifications: [],
      isLastPage: true,
    });

    onMounted(async () => {
      getNotificationData();
    });

    const getNotificationData = async () => {
      await axios
        .get('/user-notifications', {
          params: { page: state.currentPage + 1 },
        })
        .then((response) => {
          state.currentPage = response.data.current_page;
          state.notifications = state.notifications.concat(response.data.data);
          state.isLastPage = state.currentPage === response.data.last_page;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    return {
      state,
      getNotificationData,
    };
  },
};
</script>

<style></style>
